export const isIE11 = () => {
  return window.MSInputMethodContext && document.documentMode;
};

export const isSafari = () => {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};
